module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-unknown-5.3f373066.svg";